

export const getAll = (auth, query) => {
  let url = '/orders';

  if (query) {
    url = `${url}?${query}`;
  }

  return auth.fetch(url, { method: 'GET' });
}

export const getOrderByTrackingNumber = (auth, tracking) => {
  const url = `/orders/${tracking}`;
  return auth.fetch(url, { method: 'GET' });
}

export const saveOrder = (auth, order) => {
  const url = '/orders';
  return auth.fetch(url, { method: 'POST', body: JSON.stringify(order) });
}

export const updateOrder = (auth, order) => {
  const url = `/orders/${order.id}`;
  return auth.fetch(url, { method: 'PUT', body: JSON.stringify(order) });
}

export const updateOrders = (auth, orders) => {
  const url = '/orders/update/batch';
  return auth.fetch(url, { method: 'PUT', body: JSON.stringify(orders) });
}

export const voidOrder = (auth, trackingNumber) => {
  const url = `/orders/void/${trackingNumber}`;
  return auth.fetch(url, { method: 'DELETE' });
}

export const scanInByTrackingNumber = (auth, tracking) => {
  const url = `/orders/${tracking}/scan`;
  return auth.fetch(url, { method: 'GET' });
}


// WEBPACK FOOTER //
// ./src/services/OrderService.js